import { Card, Row, Col } from "reactstrap";
import React, { useEffect, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { payAndComplete } from "../../../api/controller/MyVesselController";
import { Loader } from "../../../custom/components/Loader";
import sampleDock from "../../../assets/images/sampleDock.jpg";
import moment from "moment";
import { STORAGE_PUBLIC_BASE } from "../../../custom/helpers/storagePublicBase";

const Initial = ({
  goToMyVessels,
  goToOtherVessels,
  goToRequestVesselAccess,
  goToAddVessel,
  myVessels,
  otherVessels,
  queue,
  setCurrentScreen,
  zones,
}) => {
  const [loading, setLoading] = useState(false);
  const [paymentConfirmAlert, setPaymentConfirmAlert] = useState(false);
  const [successDlg, setSuccessDlg] = useState(false);
  const [successDlgText] = useState(
    "The payment has been processed successfully"
  );
  const [errorDlg, setErrorDlg] = useState(false);
  const [errorDlgText, setErrorDlgText] = useState(
    "The payment failed. Please check vessel balance."
  );

  useEffect(() => {
    // setSweet_timer(true);
    console.log("queue", queue);
    console.log("zones", zones);
  }, [queue, zones]);

  const handlePay = async ({ dockingReq }) => {
    setLoading(true);
    setPaymentConfirmAlert(false);
    const response = await payAndComplete({
      DockingRequest: dockingReq.id,
    });
    if (response.Status === "error") {
      setErrorDlgText(response.Message);
      setErrorDlg(true);
    }
    setLoading(false);
  };

  return (
    <React.Fragment>
      <Loader loading={loading} transparent />

      <Row>
        {queue &&
          queue.map((item, key) => (
            <Col className="col-12 col-md-6 col-lg-6 col-xl-6">
              <div
                key={key}
                className="rounded-3 mb-4 bg-light bg-opacity-50" style={{boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)"}}
              >
                <div
                  className="border"
                  style={{ borderRadius: "8px 8px 8px 8px" }}
                >
                  <div
                    className="row"
                    style={{ borderRadius: "8px 8px 0px 0px" }}
                  >
                    <div
                      className="col-4 px-4 py-2  d-flex align-items-center justify-content-center"
                      style={{ borderRadius: "8px 0px 0px 0px" }}
                    >
                      <span className="text-success fs-6 fw-bold">
                        {item?.docking_request?.status}
                      </span>
                    </div>
                    <div className="col-4 px-4 py-2 d-flex align-items-center justify-content-center">
                      <span className="fs-3 fw-bold">{item?.queue_number}</span>
                    </div>
                    <div
                      className="col-4 py-2 px-4 d-flex align-items-center justify-content-end"
                      style={{ borderRadius: "0px 8px 0px 0px" }}
                    >
                      {item?.ahead?.length > 0 && (
                        <>
                          <span className="fs-3 fw-bold">
                            {item?.ahead?.length}
                          </span>
                          &nbsp;&nbsp;
                          <span className="text-secondary fs-6">Waiting</span>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between pb-2 border-top pt-2">
                    <div className="px-3">
                      <span className="fs-4 text-secondary">
                        {item.vessel_name}
                      </span>
                    </div>
                    <div className="px-3 d-flex align-items-center">
                      <span className="fs-6 text-secondary">
                        Docked at: <span className="fw-bold">{item?.docking_request?.start_time ? moment(item?.docking_request?.start_time).format('DD MMM HH:mm') : ''}</span>
                      </span>
                    </div>
                  </div>
                  <div className="position-relative">
                    <img
                      src={zones.find(zone => zone.id === item?.docking_request?.zone?.id)?.image ? STORAGE_PUBLIC_BASE + zones.find(zone => zone.id === item?.docking_request?.zone?.id)?.image : sampleDock}
                      alt={zones.find(zone => zone.id === item?.docking_request?.zone?.id)?.name || "Zone Image"}
                      style={{
                        width: "100%",
                        height: "auto",
                        objectFit: "contain",
                        // borderBottom: "1px solid rgba(222, 226, 230, 0.34)",
                      }}
                    />
                    <div
                      className="p-3"
                      style={{
                        background: "#1d1d1d",
                      }}
                    >
                      <div className="d-flex justify-content-between">
                        <span className="text-white fs-4">{item.type}</span>
                        <span className="text-white fs-4">
                          {item?.docking_request?.zone?.name || "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                  {item?.docking_request?.status === "PAYMENT PENDING" ? (
                    <div className="m-3">
                      <div className="">
                        <p className="text-secondary">
                          Thank you for using our service. Please click the
                          button below to settle the payment.
                        </p>
                        <SimpleButton
                          color={"success"}
                          icon={"mdi mdi-cash-check"}
                          text={"Pay Now"}
                          clickFn={setPaymentConfirmAlert}
                        />
                      </div>
                      {paymentConfirmAlert ? (
                        <SweetAlert
                          title="Settle Payment"
                          showCancel
                          confirmBtnText="Proceed"
                          confirmBtnBsStyle="success"
                          cancelBtnBsStyle="danger"
                          onConfirm={() => {
                            handlePay({ dockingReq: item?.docking_request });
                          }}
                          onCancel={() => setPaymentConfirmAlert(false)}
                        >
                          <h6>Bill amount:</h6>
                          <h1>
                            <span className="font-weight-semibold text-secondary">
                              MVR
                            </span>
                            &nbsp;&nbsp;
                            <span className="font-weight-semibold text-primary">
                              {item?.docking_request?.due_amount}
                            </span>
                          </h1>
                        </SweetAlert>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              </div>
            </Col>
          ))}
      </Row>
      <div className="p-3 border rounded-3 shadow-sm mb-3">
        <span className="fs-5 fw-bold">Manage Vessels</span>
        <Row>
          <Col className="col-12 col-md-4 col-lg-4 col-xl-3">
            <div className="mt-2">
              <SimpleButton
                color={"primary"}
                icon={"mdi mdi-chevron-right"}
                text={"My Vessels"}
                clickFn={goToMyVessels}
              />
            </div>
          </Col>
        </Row>
        {otherVessels && otherVessels.length > 0
          ? otherVessels.map((u, k) => (
              <div key={k} className="mt-2">
                <Row>
                  <Col className="col-md-4 col-lg-4 col-xl-3">
                    <SimpleButton
                      color={"primary"}
                      icon={"mdi mdi-chevron-right"}
                      text={`${u.owner_name}'s Vessels`}
                      clickFn={() => goToOtherVessels(u)}
                    />
                  </Col>
                </Row>
              </div>
            ))
          : null}
        <div className="mt-2">
          <Row>
            <Col className="col-md-4 col-lg-4 col-xl-3">
              <SimpleButton
                color={"primary"}
                icon={"mdi mdi-chevron-right"}
                text={"Request Vessel Access"}
                clickFn={goToRequestVesselAccess}
              />
            </Col>
          </Row>
        </div>
      </div>
      {successDlg ? (
        <SweetAlert
          success
          title={"Thank you!"}
          confirmBtnText={"Close"}
          onConfirm={() => {
            setSuccessDlg(false);
          }}
        >
          <span>{successDlgText}</span>
        </SweetAlert>
      ) : null}
      {errorDlg ? (
        <SweetAlert
          error
          title={"Payment error!"}
          confirmBtnText={"Close"}
          onConfirm={() => {
            setErrorDlg(false);
          }}
        >
          {errorDlgText}
        </SweetAlert>
      ) : null}
    </React.Fragment>
  );
};
export default Initial;

const SimpleButton = ({ color, icon, text, clickFn }) => {
  return (
    <div onClick={() => clickFn(true)}>
      <Card
        className={`px-3 py-2 mb-0 bg-${color} text-white`}
        style={{ cursor: "pointer" }}
      >
        <Row>
          <Col
            className="col-10 align-middle"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <span className=" fs-6 text-light">{text}</span>
          </Col>
          <Col
            className="col-2 align-middle"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <span
                className={`${icon} align-middle text-white`}
                style={{ fontSize: "20px" }}
              />
            </div>
          </Col>
        </Row>
      </Card>
    </div>
  );
};
